import { mapState } from "vuex";

export default {
  computed: {
    ...mapState("clients", ["salesPersonList"])
  },
  methods: {
    FilterNonActiveUsers(arr) {
      if (arr) {
        return arr.filter(user => user.active !== 0);
      }
      return this.salesPersonList.filter(user => user.active !== 0);
    }
  }
};
